import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function GroupUsersAdd({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M3 21C3 19.07 4.564 17.5 6.49 17.5H10.5C12.43 17.5 13.99 19.064 13.99 20.99M16 17.506H17.5C19.43 17.506 20.99 19.07 20.99 20.996M17.3789 4.50004H21.6215M19.5002 6.62136V2.37872M8.5 8.50603C8.10603 8.50603 7.71593 8.58362 7.35195 8.73439C6.98797 8.88515 6.65726 9.10613 6.37868 9.38471C6.1001 9.66328 5.87913 9.994 5.72836 10.358C5.5776 10.722 5.5 11.1121 5.5 11.506C5.5 11.9 5.5776 12.2901 5.72836 12.6541C5.87913 13.0181 6.1001 13.3488 6.37868 13.6273C6.65726 13.9059 6.98797 14.1269 7.35195 14.2777C7.71593 14.4284 8.10603 14.506 8.5 14.506C8.89397 14.506 9.28407 14.4284 9.64805 14.2777C10.012 14.1269 10.3427 13.9059 10.6213 13.6273C10.8999 13.3488 11.1209 13.0181 11.2716 12.6541C11.4224 12.2901 11.5 11.9 11.5 11.506C11.5 11.1121 11.4224 10.722 11.2716 10.358C11.1209 9.994 10.8999 9.66328 10.6213 9.38471C10.3427 9.10613 10.012 8.88515 9.64805 8.73439C9.28407 8.58362 8.89397 8.50603 8.5 8.50603ZM16 10.506C15.4696 10.506 14.9609 10.7167 14.5858 11.0918C14.2107 11.4669 14 11.9756 14 12.506C14 13.0365 14.2107 13.5452 14.5858 13.9202C14.9609 14.2953 15.4696 14.506 16 14.506C16.5304 14.506 17.0391 14.2953 17.4142 13.9202C17.7893 13.5452 18 13.0365 18 12.506C18 11.9756 17.7893 11.4669 17.4142 11.0918C17.0391 10.7167 16.5304 10.506 16 10.506Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default GroupUsersAdd;